import { post, get } from "@/utils/utils";
import { compact } from "lodash";
import moment from "moment";

const stock = {
  state: {
  },
  mutations: {
    // QUERY_SAVED_HEMIAO_VISUAL_REPORT() {},
    // QUERY_HEMIAO_VISUAL_REPORT_HEADER() {},
    // QUERY_SALES_CHANNELS() {},
    // QUERY_GOODS_GROUP_LIST() {},
    // SCRM_WW_AUTH_INFO_QUERY_CONFIG() {},
    // SCRM_WW_AUTH_INFO_EDIT_CONFIG() {},
    // SCRM_WW_CUSTOMER_INFO_QUERY_CUSTOMIZED_PAGE_LIST() {},
    // SCRM_WW_SYNC_RECORD_SYNC_WX_DATA() {},
    // SCRM_WW_TAG_GROUP_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_CUSTOMER_INFO_UPDATE_MEMBER_TAG() {},
    // SCRM_WW_MATERIAL_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_MATERIAL_INFO_ADD() {},
    // SCRM_WW_MATERIAL_INFO_EDIT() {},
    // SCRM_WW_MATERIAL_INFO_REMOVE_BY_MODEL() {},
    // SCRM_WW_MSG_TEMPLATE_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_MSG_TEMPLATE_INFO_ADD() {},
    // SCRM_WW_MSG_TEMPLATE_INFO_EDIT() {},
    // SCRM_WW_MSG_TEMPLATE_INFO_REMOVE_BY_MODEL() {},
    // SCRM_WW_MSG_TEMPLATE_INFO_QUERY_BY_ID() {},
    // SCRM_WW_USER_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_DEPT_INFO_QUERY_ROOT_LIST() {},
    // SCRM_WW_DEPT_INFO_QUERY_CHILD_LIST() {},
    // SCRM_WW_DEPT_INFO_QUERY_ROOT_TREE() {},
    // SCRM_WW_DEPT_INFO_QUERY_DEPT_USER_LIST() {},
    // SCRM_WW_USER_INFO_QUERY_CUR_DEPT_USER_LIST_BY_DEPT_ID() {},
    // SCRM_WW_QR_CODE_INFO_ADD_USER_QR_CODE() {},
    // SCRM_WW_QR_CODE_INFO_UPDATE_USER_QR_CODE() {},
    // SCRM_WW_QR_CODE_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_QR_CODE_INFO_QUERY_BY_ID() {},
    // SCRM_WW_GROUP_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_SYNC_RECORD_QUERY_LAST_RECORD() {},
    // SCRM_WW_GROUP_MEMBER_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_GROUP_INFO_QUERY_GROUP_STAT_INFO_BY_ID() {},
    // SCRM_WW_TAG_INFO_QUERY_PAGE_LIST() {},
    // ADD_GROUP_QR_CODE() {},
    // QUERY_GROUPS_MEMBER_NUM_BY_ID() {},
    // QUERY_QR_CODE_GROUPS_DETAIL() {},
    // UP_GROUPS_QR_CODE_BY_CONF_ID() {},
    // DOWNLOAD_QR_CODES() {},
    // DEL_GROUP_QR_CODE() {},
    // QUERY_PAGE_OPERATE_RECORD() {},
    // GET_MODEL_BY_PARAM_CODE() {},
    // EDIT_VALUE_BY_ID() {},
    // QUERY_MOMENTS_LIST() {},
    // ADD_WX_MOMENTS_TASK() {},
    // SCRM_WW_QR_CODE_INFO_DEL_USER_QR_CODE() {},
    // SCRM_WW_QR_CODE_INFO_DOWNLOA_BATCH() {},
    // SHARE_DATA_SAVE() {},
    // MOMENTS_QUERY_DETAIL_BY_TIME() {},
    // MOMENTS_QUERY_DETAIL_BY_USER_ID() {},
    // MOMENTS_QUERY_DETAIL_BY_CONTENT() {},
    // MOMENTS_DETAIL() {},
    // MOMENTS_STOP_WX_MOMENTS_TASK() {},
    // CANCEL_WX_MOMENTS_TASK() {},
    // SCRM_WW_QR_CODE_INFO_QUERY_TOTAL_STAT_DATA_BY_ID() {},
    // SCRM_WW_QR_CODE_INFO_QUERY_DAILY_STAT_DATA_BY_ID() {},
    // SCRM_WW_MULTI_CODE_INFO_ADD_MULTI_CODE_INTEGRATION() {},
    // SCRM_WW_MULTI_CODE_INFO_QUERY_PAGE_LIST() {},
    // SCRM_WW_MULTI_CODE_INFO_QUERY_BY_ID() {},
    // SCRM_WW_MULTI_CODE_INFO_QUERY_TEMP_GROUPS_URL() {},
    // GROUP_MSG_ADD() {},
    // GROUP_MSG_PAGE_LIST() {},
    // GROUP_MSG_DETAIL() {},
    // GROUP_MSG_BATCH_DEL() {},
    // REPORTS_INDEX_OVERVIEW() {},
    // REPORTS_INDEX_CUSTOMER_TRENDS() {},
    // REPORTS_DEPT_OVERVIEW() {},
    // REPORTS_DEPT_TRENDS() {},
    // REPORTS_ACHIEVEMENT_OVERVIEW() {},
    // REPORTS_ACHIEVEMENT_TRENDS_GROUP_BY_USER() {},
    // REPORTS_GROUP_CHAT_OVERVIEW() {},
    // REPORTS_GROUP_CHAT_TRENDS() {},
    // GROUP_CHAT_GET_TRENDS_GROUP_BY_OWNER() {},
    // CUSTOMER_OVERVIEW() {},
    // CUSTOMER_TRENDS() {},
    // STORE_COMPONENT_LIST() {},
    // SCRM_MARKETING_CREATE() {},
    // SCRM_MARKETING_DETAIL() {},
    // SCRM_MARKETING_LIST() {},
    // SCRM_MARKETING_EDIT() {},
    // SCRM_MARKETING_DELETE() {},
    // STORE_COMPONENT_COLUMN_DETAIL() {},
    // STORE_COMPONENT_COLUMNS() {},
    // SCRM_MARKETING_CREATE_PROCESS() {},
    // SCRM_MARKETING_EDIT_PROCESS() {},
    TAG_CATEGORY_INFO_QUERY_PAGE_LIST() {},
    TAG_CATEGORY_INFO_ADD() {},
    TAG_CATEGORY_INFO_EDIT() {},
    TAG_BASIC_INFO_ADD() {},
    TAG_BASIC_INFO_QUERY_PAGE_LIST() {},
    TAG_BASIC_INFO_QUERY_QUERY_BY_ID() {},
    TAG_BASIC_INFO_EDIT() {},
    TAG_BASIC_INFO_QUERY_TAG_LIST_BY_CATEGORY_ID() {},
    BATCH_ADD_TAG_DATA_RANGE_CONFIG_LIST() {},
    QUERY_TAG_BASIC_INFO_AND_DATA_RANGE_CONFIG_LIST_BY_TAG_BASIC_ID() {},
    QUERY_TAG_BASIC_INFO_AND_DATA_COLUMN_CONFIG_LIST_BY_TAG_BASIC_ID() {},
    TAG_DATA_RANGE_CONFIG_ADD() {},
    TAG_DATA_RANGE_CONFIG_EDIT() {},
    TAG_DATA_RANGE_CONFIG_REMOVE_BY_MODEL() {},
    TAG_DATA_COLUMN_CONFIG_ADD() {},
    TAG_DATA_COLUMN_CONFIG_EDIT() {},
    TAG_DATA_COLUMN_CONFIG_REMOVE_BY_MODEL() {},
    // SCRM_MARKETING_AUDIT() {},
    // STATIC_TAG_OPERATE_QUERY_TAG_LIST_BY_BELONG_ID() {},
    // STATIC_TAG_OPERATE_UPDATE_STATIC_TAG_BY_BELONG_ID() {},
    // MICRO_STATIC_TAG_OPERATE_UPDATE_STATIC_TAG_BY_BELONG_ID() {},
    // TAG_CATEGORY_INFO_QUERY_STATIC_FLAT_STRUCT() {},
    STATIC_TAG_OPERATE_GET_TAG_DATA_COUNT() {},
    // GET_FACT_TABLE_MEMBER_INFO() {},
    // GET_FACT_TABLE_MEMBER_CATEGORY_PREFERENCE() {},
    // GET_FACT_TABLE_MEMBER_BRAND_PREFERENCE() {},
    // SCRM_WW_CUSTOMER_FOLLOW_TAG_REL_QUERY_TAG_LIST_BY_CUSTOMER_ID() {},
    // SCRM_WW_GROUP_MEMBER_INFO_QUERY_GROUP_LIST_BY_CUSTOMER_ID() {},
    // EXTRACT_TAG_DATA_TASK() {},
    EXPORT_TAG_DATA_CSV() {},
    // MARKETING_TASK_LIST() {},
    // MARKETING_TASK_INSTANCE() {},
    // GUIDER_TASK_LIST() {},
    // GUIDER_TASK_ADD() {},
    // GUIDER_TASK_UPDATE() {},
    // GUIDER_RULE_INFO() {},
    // MATE_TEMPLATE_LIST() {},
    // MOBILE_GUIDER_RULE_INFO() {},
    // GUIDER_RULE_SETTING() {},
    // GUIDER_TASK_DETAIL() {},
    // GUIDER_TASK_DELETE() {},
    // MOBILE_GUIDER_TASK_LIST() {},
    // MOBILE_GUIDER_TASK_DETAIL() {},
    // MOBILE_GUIDER_TASK_DETAIL_STATUS() {},
    // QUERY_SYS_CATEGORY_FRONTEND_DISPLAY_ROOT_NODE_LIST() {},
    QUERY_SYS_CATEGORY_FRONTEND_DISPLAY_CHILD_NODE_LIST_BY_SYS_CATEGORY_FRONTEND_DISPLAY_ROOT_ID() {},
    // MICRO_QUERY_SYS_CATEGORY_FRONTEND_DISPLAY_CHILD_NODE_LIST_BY_SYS_CATEGORY_FRONTEND_DISPLAY_ROOT_ID() {},
    SYS_CATEGORY_FRONTEND_DISPLAY_INFO_ADD() {},
    SYS_CATEGORY_FRONTEND_DISPLAY_INFO_UPDATE_BY_ID() {},
    QUERY_TAG_LIST_BY_SYS_CATEGORY_FRONTEND_DISPLAY_ID() {},
    // BATCH_ADD_TAG_DATA_COLUMN_CONFIG_LIST() {},
    // UPDATE_STATIC_TAG_BY_LIST() {},
    // IMPORT_CUSTOM_TAG_DATA() {},
    // TAG_CUSTOM_SOURCE_INFO_QUERY_PAGE_LIST() {},
    // TAG_CUSTOM_SOURCE_INFO_QUERY_BY_ID() {},
    // TOPIC_GROUP_LIST() {},
    // TOPIC_GROUP_CREATE() {},
    // TOPIC_GROUP_UPDATE() {},
    // TOPIC_LIST() {},
    // TOPIC_CREATE() {},
    // TOPIC_EDIT() {},
    // TOPIC_DETAIL() {},
    // TOPIC_DELETE() {},
    SAVE_PEOPLE_PACKAGE() {},
    ESTIMATE_PEOPLE_PACKAGE() {},
    TAG_DATA_CALC_RULE_INFO_QUERY_PAGE_LIST() {},
    TAG_OPERATE_EXEC_PEOPLE_PACKAGE() {},
    SYS_CATEGORY_FRONTEND_DISPLAY_INFO_QUERY_BY_NAME() {},
    SCRM_SCHEDULING_RECORD_QUERY_PAGE_LIST() {},
    DOWNLOAD_PEOPLE_PACKAGE_RESULT() {},
    // GUIDER_TASK_GROUP_MSG() {},
    // GUIDER_TASK_MOMENT() {},
    // GUIDER_TASK_FOLLOW() {},
    // GUIDER_TASK_ACCESS_TOKEN() {},
    // GUIDER_TASK_GET_AGENT_TOKEN() {},
    // GUIDER_TASK_GET_CORP_INFO() {},
    // GUIDER_TASK_GET_USER_INFO() {},
    // WE_COM_LOGIN_GET_CORP_INFO() {},
    // WE_COM_LOGIN_GET_WE_COM_LOGIN_USER_INFO() {},
    // COMMON_DICT_ITEMS() {},
    // SCRM_MEMBER_GRADE_NAME() {},
    // SCRM_MEMBER_GRADE() {},
    // GUIDER_TASK_INFO() {},
    // GUIDER_TASK_GUIDER_INFO() {},
    // GUIDER_TASK_STATUS_SUMMARY() {},
    // GUIDER_TASK_STATISTICS() {},
    // GET_FACT_TABLE_MEMBER_ACTION_LIST() {},
    // GUIDER_TASK_MEMBER_FOLLOW() {},
    // GUIDER_TASK_MEMBER_FOLLOWUP() {},
    // GET_FACT_TABLE_ORDER_MAIN_LIST() {},
    // MARKETING_SETTING_INFO() {},
    // MARKETING_SETTING() {},
    // DK_ADB_MEMBER_METRICS_SEARCH() {},
    // MEMBER_METRICS_SEARCH_QUERY_NEW_MEMBER_AGGS_DATA() {},
    // MICRO_DK_ADB_MEMBER_METRICS_SEARCH_QUERY_AGGS_DATA() {},
    // GET_SCRM_STRAFF_INFO_BY_WE_COM() {},
    // SMS_SIGN_LIST() {},
    // SMS_TEMPLATE_LIST() {},
    // MARKETING_GROUP_LIST() {},
    // MARKETING_GROUP_ADD() {},
    // MARKETING_GROUP_UPDATE() {},
    // DICT_CODE_SCRM_DKADB_COMPANY_NAME() {},
    // DICT_CODE_SCRM_MEMBER_GRADE_CODE() {},
    // DICT_CODE_SCRM_DKADB_STAFFID() {},
    // PEOPLE_BASIC_SEARCH_QUERY_DATA() {},
    // MARKETING_STATISTICS() {},
    // MARKETING_GROUP_ORDERPAGE() {},
    // STORE_SYSTEM_PARAM_INFO_GET_MODEL_BY_PARAM_CODE() {},
    // STORE_SYSTEM_PARAM_INFO_EDIT_VALUE_BY_ID() {},
    // MARKETING_OVERVIEW_QUERY_AGGS_DATA() {},
    // MARKETING_OVERVIEW_QUERY_MEMBER_NUM_BY_HIS_DATE() {},
    // MEMBER_OVERVIEW_SEARCH_QUERY_MEMBER_SALE_AGG_DATA() {},
    // MEMBER_OVERVIEW_SEARCH_QUERY_PURCHASE_FREQ_SUMMARY() {},
    // SCRM_STAFF_INFO_QUERY_FULL_INFO_BY_STAFFID() {},
    // SCRM_STAFF_INFO_EDITBYSTAFFID() {},
    // SCRM_STAFF_INFO_QUERYDATABYSTAFF() {},
    // SCRM_STAFF_INFO_QUERY_PAGE_LIST() {},
    // SCRM_STAFF_INFO_QUERY_ROLE_INFO() {},
    // SCRM_STAFF_INFO_EMP_EDIT() {},
    // MOBILE_GUIDER_TASK_TEAM_TASK() {},
    TAG_OPERATE_RUN_TAG_DATA_CALC() {},
    // SCRM_STAFF_INFO_QUERY_DEPART_INFO() {},
    // SHOP_TRIGGER_EMP_LIST() {},
    // DEPT_TRIGGER_EMP_LIST() {},
    // SHOP_TRIGGER_DEPT_LIST() {},
    // SHOP_TRIGGER_ADD() {},
    // DEPT_TRIGGER_ADD() {},
    // SCRM_STAFF_INFO_QUERY_STAFF_PAGE_LIST() {},
    // DICT_ITEMS_GRADE() {},
    SCRM_GROUP_ANALYSIS() {},
    // SCRM_HOME_DATEBORD() {},
    // SCRM_MOBILE_DATEBOARD() {},
    // GET_FACT_TABLE_MEMBER_INFO_LIST() {},
    // DYNAMICS_DATA_BASIC_INFO_QUERY_PAGE_LIST() {},
    // DYNAMICS_DATA_BASIC_INFO_ADD() {},
    // DYNAMICS_DATA_BASIC_INFO_EDIT() {},
    // DYNAMICS_DATA_BASIC_INFO_QUERY_BY_ID() {},
    // DYNAMICS_DATA_COLUMN_CONFIG_BATCH_ADD_DYNAMICS_DATA_COLUMN_DATA_COLUMN_CONFIG_LIST() {},
    // DYNAMICS_DATA_COLUMN_CONFIG_ADD() {},
    // DYNAMICS_DATA_COLUMN_CONFIG_EDIT() {},
    // DYNAMICS_DATA_COLUMN_CONFIG_QUERY_BY_ID() {},
    // DYNAMICS_DATA_AGGS_PROC_QUERY_DYNAMICS_DATA_AGGS_STATS_RESULT() {},
    // STATS_USER_OVERVIEW() {},
    // STORE_SYSTEM_PARAM_INFO_GET_PARAM_VALUE_NO_TOKEN() {},
    // SCRM_WW_GROUP_INFO_GROUP_OWNER_TASK() {},
    // CUSTOMER_STATIC() {},
    // SALE_DATA() {},
    // DYNAMICS_SALE_DATA() {},
    // DYNAMICS_DATA_AGGS_PROC_QUERY_DYNAMICS_DATA_AGGS_LIST_RESULT() {},
    // QUERY_DYNAMICS_DATA_AGGS_STATS_RESULT() {},
    // QUERY_DYNAMICS_DATA_AGGS_LIST_RESULT() {},
    // QUERY_COUNT_DYNAMICS_DATA_MULTIPLY_TABLE() {},
    // QUERY_DYNAMICS_DATA_NORMAL_LIST_RESULT() {},
    // GET_PLUS_MEMBER_INCREASE_CARD_LIST() {},
    GET_PLUS_MEMBER_CARD_LIST() {},
    // TASK_REPORT() {},
    // DEPT_DATE_SCOPE() {},
    // STAFF_DATE_SCOPE() {},
    // TAG_TRENDS_QUERY_DATE_RANGE_LIST() {},
    // GUIDER_TASK_REPORT_DATE() {},
    // GUIDER_TASK_RANK() {},
    // GUIDER_TASK_RANK_GUIDER() {},
    // QUERY_ACT_TYPE_LIST() {},
    // MOBILE_GUIDER_TASK_FEEDBACKS() {},
    // GET_MEMBER_ANALYSIS_CATEGORY_PREFERENCE() {},
    // GET_MEMBER_ANALYSIS_BRAND_PREFERENCE() {},
    // SEARCH_USER_PERMISSION() {},
    // UPDATE_FACT_TABLE_MEMBER() {},
    // DYNAMICS_DATA_DASHBOARD_PAGE_INFO_QUERY_PAGE_LIST() {},
    // DYNAMICS_DATA_DASHBOARD_PAGE_INFO_ADD() {},
    // DYNAMICS_DATA_DASHBOARD_PAGE_INFO_EDIT() {},
    // DYNAMICS_DATA_DASHBOARD_PAGE_INFO_QUERY_BY_ID() {},
    // DYNAMICS_DATA_REPORT_TEMPLATE_INFO_QUERY_PAGE_LIST() {},
    DYNAMICS_DATA_REPORT_TEMPLATE_INFO_OBTAIN_DYNAMICS_DATA_REPORT() {},
    // MARKETING_SBU_MSG_LIST() {},
    // GUIDER_TASK_EXPORT() {},
    // MICRO_TOPIC_GROUP_LIST() {},
    // MICRO_TOPIC_LIST() {},
    // GET_FACT_TABLE_MEMBER_MILK_CATEGORY_PREFERENCE() {},
    // GET_FACT_TABLE_MEMBER_PAPER_CATEGORY_PREFERENCE() {},
    // EXPORT_FACT_TABLE_MEMBER_INFO_LIST() {},
    // SCRM_MARKETING_RD() {},
    // MICRO_SCRM_WW_QR_CODE_INFO_QUERY_PAGE_LIST() {},
    // MICRO_SCRM_WW_QR_CODE_INFO_QUERY_DAILY_STAT_DATA_BY_ID() {},
    // MICRO_SCRM_WW_QR_CODE_INFO_QUERY_BY_Id() {},
    // MICRO_SCRM_WW_QR_CODE_INFO_QUERY_TOTAL_STAT_DATA_BY_ID() {},
    // SCRM_FORM_LIST() {},
    // SCRM_FORM_QUERYCOMMONITEMS() {},
    // SCRM_FORM_ADD() {},
    // SCRM_FORM_DETAIL() {},
    // SCRM_FORM_UPDATE() {},
    // SCRM_FORM_DELETE() {},
    // SCRM_FORM_DATA() {},
    // SCRM_FORM_CLOSE() {},
    // SCRM_FORM_DATADETAIL() {},
    // SCRM_FORM_SHARE() {},
    // WECHATCP_CORP_SCRMWWMATERIALINFO_DETAIL() {},
    // SCRM_TOPIC_STAT() {},
    // SCRM_TOPIC_EMPSTAT() {},
    // MICRO_CORP_DATA_SCPOE_QUERY_DEPART_DATA_SCOPE() {},
    // MICRO_CORP_DATA_SCPOE_QUERY_STAFF_DATA_SCOPE() {},
    // MICRO_DYNAMICS_DATA_DASHBOARD_PAGE_INFO_QUERY_BY_ID() {},
    // SCRM_FORM_SUBMIT() {},
    // DATA_SCPOE_GET_DATA_SCOPE() {},
    // SCRM_FORM_MEMBERDETAIL() {},
    // SUBMIT_DATA() {},
    // SCRM_FORM_SUBMIT_DETAIL() {},
    // QUERY_ALIAS_MAPPING_LIST_BY_CATEGORY_FRONTEND_DISPLAY_ID() {},
    // SYS_ALIAS_MAPPING_INFO_ADD() {},
    // SYS_ALIAS_MAPPING_INFO_EDIT() {},
    // SYS_ALIAS_MAPPING_INFO_QUERY_BY_ID() {},
    // MICRO_SYS_ALIAS_MAPPING_INFO_QUERY_BY_ID() {},
    // SYS_ALIAS_MAPPING_INFO_REMOVE_BY_MODEL() {},
    // MICRO_SYS_CATEGORY_FRONTEND_DISPLAY_INFO_QUERY_BY_NAME() {},
    // GET_CROWD_PACKAGE_WECOM_EXTERNAL_CONTACT() {},
    // TOPIC_STAT_ADD() {},
    // TAG_OPERATE_PUSH_TO_WE_COM_GROUP_TAG() {},
    // TAG_OPERATE_PUSH_TO_WE_COM_TAG_USER() {},
    // SCRM_MOBILE_GUIDER_TASK_FOLLOW_INFO() {},
    // SCRM_MOBILE_GUIDER_TASK_STATIC() {},
    // SCRM_MOBILE_GUIDER_TASK_CNT() {},
    // SCRM_MOBILE_GUIDER_TASK_TASKMOBILESTATIC() {},
    // QUERY_TASK_MOBILEHOMETASKSTATISTICS() {},
    // GETFACTTABLEMEMBERSTATS() {},
    // MOBILE_HOME_DAY_TASK_DETAIL_LIST() {},
    // QUERY_STORE_TASK_RULE_TYPE_COUNT() {},
    // MOBILE_GUIDER_TASK_INFO() {},
    // GUIDER_TASK_TASKDEPTINFO() {},
    // GET_MOBILE_GUIDER_TAB_TASK_LIST() {},
    // SCRM_GUIDER_TASK_EXPORTTASK() {},
    // CANVAS_DAILY_STATISTICS() {},
    // QUERY_AUTH_TAGLIST() {},
    // GET_MARKETING_PARAM_VALUELIST() {},
    // QUERY_MESSAGE_TEMPLATE_PAGE() {},
    // DELETE_MESSAGE_TEMPLATE_PAGE() {},
    // EDIT_MESSAGE_TEMPLATE_PAGE() {},
    // ADD_MESSAGE_TEMPLATE_PAGE() {},
    // QUERY_MESSAGE_TEMPLATE_BY_ID() {},
    // QUERY_MESSAGE_TEMPLATE_CATEGORY() {},
    // QUERY_MESSAGE_RULES_PAGE() {},
    // ADD_MESSAGE_RULES() {},
    // QUERY_MESSAGE_RULES_BY_ID() {},
    // EDIT_MESSAGE_RULES() {},
    // PUSH_MESSAGE() {},
    // QUERY_THIRD_INTERFACE_INVOKE_PAGE() {},
    // DEL_MESSAGE_RULES() {},
    // QUERY_USER_STAFF_COMPAGE() {},
    // SYNC_USER_STAFF_COMP() {},
    // CANCEL_USER_STAFF_COMP() {},
    // EDIT_TAG_CUSTOM_SOURCEINFO() {},
    // CHECK_USAGE_TAG_CUSTOM_SOURCEINFO() {},
    // DEL_ALL_INFO_BYID() {},
    // EDIT_TAG_DATA_CALC_RULEINFO() {},
    CHECKUSAGE_TAG_DATA_CALC_RULEINFO() {},
    DEL_CALC_TAGALLINFO_BYID() {},
    // UPDATE_TASK_NAME() {},
    // EXPORT_TAG_DATA_CSVCUSTOM() {},
    QUERY_EXPORT_TAGFIELD() {},
    // EXPORT_SUMMARY_LIST() {},
    // OBTAIN_DYNAMICS_DATA_REPORT() {},
    // QUERY_GROUP_BRAND_STATISTICS() {},
    // QUERY_BRAND_RULE_PAGE() {},
    // QUERY_BRAND_MEMBERPAGE() {},
    // ADD_BRAND_Rule() {},
    // PUSH_THIS_MONTH_BRAND_NEW_MEMBER() {},
    // EXPORT_BRAND_MEMBER() {},
    // ADD_BRAND_MEMBER() {},
    // ESTIMATE_PEOPLE_PLUS_PACKAGE() {},
    // GET_MEMBER_INFO_LIST_API() {},
    // MARKETING_MATE_TEMPLATE_LIST() {},
    // TAG_ORMINFO_ADD() {},
    // TAG_ORMINFO_EDIT() {},
    // QUERY_TAG_ORMINFO_BYID() {},
    // QUERY_YAG_ORMINFO_LIST() {},
    // REMOVE_YAG_ORMINFO_LIST() {}
  },
  actions: {
    // queryTempDetails({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/basic/layout/detail`,
    //     name: "QUERY_TEMP_DETAILS",
    //     params
    //   });
    // },
    // queryMicroShopList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/layout_href/list`,
    //     name: "QUERY_LAYOUT_LIST",
    //     params
    //   });
    // },
    // querySavedHeMiaoVisualReport({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/reports/ssrLayoutRecord/queryReportVisualize`,
    //     name: "QUERY_SAVED_HEMIAO_VISUAL_REPORT",
    //     params
    //   });
    // },
    // queryHeMiaoVisualReportHeader({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/reports/ssrBasicConfig/queryPageList`,
    //     name: "QUERY_HEMIAO_VISUAL_REPORT_HEADER",
    //     params
    //   });
    // },
    // querySalesChannels({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/basic/spu/platform_list`,
    //     name: "QUERY_SALES_CHANNELS",
    //     params
    //   });
    // },
    // queryGoodsGroupList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/basic/spu_group/list`,
    //     name: "QUERY_GOODS_GROUP_LIST",
    //     params
    //   });
    // },
    // scrmWwAuthInfoQueryConfig({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwAuthInfo/queryConfig`,
    //     name: "SCRM_WW_AUTH_INFO_QUERY_CONFIG",
    //     params
    //   });
    // },
    // scrmWwAuthInfoEditConfig({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwAuthInfo/editConfig`,
    //     name: "SCRM_WW_AUTH_INFO_EDIT_CONFIG",
    //     params
    //   });
    // },
    // scrmWwAuthInfoQueryCustomizedPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwCustomerInfo/queryCustomizedPageList`,
    //     name: "SCRM_WW_CUSTOMER_INFO_QUERY_CUSTOMIZED_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwSyncRecordSyncWxData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwSyncRecord/syncWxData`,
    //     name: "SCRM_WW_SYNC_RECORD_SYNC_WX_DATA",
    //     params
    //   });
    // },
    // scrmWwTagGroupInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwTagGroupInfo/queryPageList`,
    //     name: "SCRM_WW_TAG_GROUP_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwCustomerInfoUpdateMemberTag({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwCustomerInfo/updateMemberTag`,
    //     name: "SCRM_WW_CUSTOMER_INFO_UPDATE_MEMBER_TAG",
    //     params
    //   });
    // },
    // scrmWwMaterialInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMaterialInfo/queryPageList`,
    //     name: "SCRM_WW_MATERIAL_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwMaterialInfoAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMaterialInfo/add`,
    //     name: "SCRM_WW_MATERIAL_INFO_ADD",
    //     params
    //   });
    // },
    // scrmWwMaterialInfoEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMaterialInfo/edit`,
    //     name: "SCRM_WW_MATERIAL_INFO_EDIT",
    //     params
    //   });
    // },
    // scrmWwMaterialInfoRemoveByModel({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMaterialInfo/removeByModel`,
    //     name: "SCRM_WW_MATERIAL_INFO_REMOVE_BY_MODEL",
    //     params
    //   });
    // },
    // scrmWwMsgTemplateInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMsgTemplateInfo/queryPageList`,
    //     name: "SCRM_WW_MSG_TEMPLATE_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwMsgTemplateInfoAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMsgTemplateInfo/add`,
    //     name: "SCRM_WW_MSG_TEMPLATE_INFO_ADD",
    //     params
    //   });
    // },
    // scrmWwMsgTemplateInfoEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMsgTemplateInfo/edit`,
    //     name: "SCRM_WW_MSG_TEMPLATE_INFO_EDIT",
    //     params
    //   });
    // },
    // scrmWwMsgTemplateInfoRemoveByModel({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMsgTemplateInfo/removeByModel`,
    //     name: "SCRM_WW_MSG_TEMPLATE_INFO_REMOVE_BY_MODEL",
    //     params
    //   });
    // },
    // scrmWwMsgTemplateInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMsgTemplateInfo/queryById`,
    //     name: "SCRM_WW_MSG_TEMPLATE_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // scrmWwUserInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwUserInfo/queryPageList`,
    //     name: "SCRM_WW_USER_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwDeptInfoQueryRootList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwDeptInfo/queryRootList`,
    //     name: "SCRM_WW_DEPT_INFO_QUERY_ROOT_LIST",
    //     params
    //   });
    // },
    // scrmWwDeptInfoQueryChildList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwDeptInfo/queryChildList`,
    //     name: "SCRM_WW_DEPT_INFO_QUERY_CHILD_LIST",
    //     params
    //   });
    // },
    // scrmWwDeptInfoQueryRootTree({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwDeptInfo/queryRootTree`,
    //     name: "SCRM_WW_DEPT_INFO_QUERY_ROOT_TREE",
    //     params
    //   });
    // },
    // scrmWwDeptInfoQueryDeptUserList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwDeptInfo/queryDeptUserList`,
    //     name: "SCRM_WW_DEPT_INFO_QUERY_DEPT_USER_LIST",
    //     params
    //   });
    // },
    // scrmWwUserInfoQueryCurDeptUserListByDeptId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwUserInfo/queryCurDeptUserListByDeptId`,
    //     name: "SCRM_WW_USER_INFO_QUERY_CUR_DEPT_USER_LIST_BY_DEPT_ID",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoAddUserQrCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/addUserQrCode`,
    //     name: "SCRM_WW_QR_CODE_INFO_ADD_USER_QR_CODE",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoUpdateUserQrCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/updateUserQrCode`,
    //     name: "SCRM_WW_QR_CODE_INFO_UPDATE_USER_QR_CODE",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/queryPageList`,
    //     name: "SCRM_WW_QR_CODE_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/queryById`,
    //     name: "SCRM_WW_QR_CODE_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // scrmWwGroupInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwGroupInfo/queryPageList`,
    //     name: "SCRM_WW_GROUP_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwSyncRecordQueryLastRecord({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwSyncRecord/queryLastRecord`,
    //     name: "SCRM_WW_SYNC_RECORD_QUERY_LAST_RECORD",
    //     params
    //   });
    // },
    // scrmWwGroupMemberInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwGroupMemberInfo/queryPageList`,
    //     name: "SCRM_WW_GROUP_MEMBER_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwGroupInfoQueryGroupStatInfoById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwGroupInfo/queryGroupStatInfoById`,
    //     name: "SCRM_WW_GROUP_INFO_QUERY_GROUP_STAT_INFO_BY_ID",
    //     params
    //   });
    // },
    // scrmWwTagInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwTagInfo/queryPageList`,
    //     name: "SCRM_WW_TAG_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // addGroupQrCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/addGroupQrCode`,
    //     name: "ADD_GROUP_QR_CODE",
    //     params
    //   });
    // },
    // queryGroupsMemberNumById({ commit }, params) {
    //   return get({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwGroupInfo/queryGroupsMemberNumById`,
    //     name: "QUERY_GROUPS_MEMBER_NUM_BY_ID",
    //     params
    //   });
    // },
    // queryQrCodeGroupsDetail({ commit }, params) {
    //   return get({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/queryQrCodeGroupsDetail`,
    //     name: "QUERY_QR_CODE_GROUPS_DETAIL",
    //     params
    //   });
    // },
    // upGroupsQrCodeByConfId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/upGroupsQrCodeByConfId`,
    //     name: "UP_GROUPS_QR_CODE_BY_CONF_ID",
    //     params
    //   });
    // },
    // downloadQrCodes({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/downloadQrCodes`,
    //     name: "DOWNLOAD_QR_CODES",
    //     params
    //   });
    // },
    // delGroupQrCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/delGroupQrCode`,
    //     name: "DEL_GROUP_QR_CODE",
    //     params
    //   });
    // },
    // queryPageOperateRecord({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/customerOperate/queryPageOperateRecord`,
    //     name: "QUERY_PAGE_OPERATE_RECORD",
    //     params
    //   });
    // },
    // getModelByParamCode({ commit }, params) {
    //   //数据字典
    //   return post({
    //     commit,
    //     url: `/storepermissions/storeSystemParamInfo/getModelByParamCode`,
    //     name: "GET_MODEL_BY_PARAM_CODE",
    //     params
    //   });
    // },
    // editValueById({ commit }, params) {
    //   //数据字典
    //   return post({
    //     commit,
    //     url: `/storepermissions/storeSystemParamInfo/editValueById`,
    //     name: "EDIT_VALUE_BY_ID",
    //     params
    //   });
    // },
    // queryMomentsList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/queryMomentsList`,
    //     name: "QUERY_MOMENTS_LIST",
    //     params
    //   });
    // },
    // addWxMomentsTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/addWxMomentsTask`,
    //     name: "ADD_WX_MOMENTS_TASK",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoDelUserQrCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/delUserQrCode`,
    //     name: "SCRM_WW_QR_CODE_INFO_DEL_USER_QR_CODE",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoDownloaBatch({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/downloaBatch`,
    //     name: "SCRM_WW_QR_CODE_INFO_DOWNLOA_BATCH",
    //     params
    //   });
    // },
    // qrCodeRecordShareDataSave({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/qrCodeRecord/share_data_save`,
    //     name: "SHARE_DATA_SAVE",
    //     params
    //   });
    // },
    // momentsQueryDetailByTime({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/queryDetailByTime`,
    //     name: "MOMENTS_QUERY_DETAIL_BY_TIME",
    //     params
    //   });
    // },
    // momentsQueryDetailByUserId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/queryDetailByUserId`,
    //     name: "MOMENTS_QUERY_DETAIL_BY_USER_ID",
    //     params
    //   });
    // },
    // momentsQueryDetailByContent({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/queryDetailByContent`,
    //     name: "MOMENTS_QUERY_DETAIL_BY_CONTENT",
    //     params
    //   });
    // },
    // momentsDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/detail`,
    //     name: "MOMENTS_DETAIL",
    //     params
    //   });
    // },
    // momentsStopWxMomentsTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/stopWxMomentsTask`,
    //     name: "MOMENTS_STOP_WX_MOMENTS_TASK",
    //     params
    //   });
    // },
    // cancelWxMomentsTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/moments/cancel`,
    //     name: "CANCEL_WX_MOMENTS_TASK",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoQueryTotalStatDataById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/queryTotalStatDataById`,
    //     name: "SCRM_WW_QR_CODE_INFO_QUERY_TOTAL_STAT_DATA_BY_ID",
    //     params
    //   });
    // },
    // scrmWwQrCodeInfoQueryDailyStatDataById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwQrCodeInfo/queryDailyStatDataById`,
    //     name: "SCRM_WW_QR_CODE_INFO_QUERY_DAILY_STAT_DATA_BY_ID",
    //     params
    //   });
    // },
    // scrmWwMultiCodeInfoAddMultiCodeIntegration({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/scrmWwMultiCodeInfo/addMultiCodeIntegration`,
    //     name: "SCRM_WW_MULTI_CODE_INFO_ADD_MULTI_CODE_INTEGRATION",
    //     params
    //   });
    // },
    // scrmWwMultiCodeInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/scrmWwMultiCodeInfo/queryPageList`,
    //     name: "SCRM_WW_MULTI_CODE_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmWwMultiCodeInfoQueryById({ commit }, params) {
    //   return get({
    //     commit,
    //     url: `/store/scrmWwMultiCodeInfo/queryById`,
    //     name: "SCRM_WW_MULTI_CODE_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // scrmWwMultiCodeInfoQueryTempGroupsUrl({ commit }, params) {
    //   return get({
    //     commit,
    //     url: `/store/scrmWwMultiCodeInfo/queryTempGroupsUrl`,
    //     name: "SCRM_WW_MULTI_CODE_INFO_QUERY_TEMP_GROUPS_URL",
    //     params
    //   });
    // },
    // groupMsgAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/groupMsg/add`,
    //     name: "GROUP_MSG_ADD",
    //     params
    //   });
    // },
    // groupMsgPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/groupMsg/pageList`,
    //     name: "GROUP_MSG_PAGE_LIST",
    //     params
    //   });
    // },
    // groupMsgDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/groupMsg/detail`,
    //     name: "GROUP_MSG_DETAIL",
    //     params
    //   });
    // },
    // groupMsgBatchDel({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/groupMsg/batch/del`,
    //     name: "GROUP_MSG_BATCH_DEL",
    //     params
    //   });
    // },
    // reportsIndexOverview({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/index/overview`,
    //     name: "REPORTS_INDEX_OVERVIEW",
    //     params
    //   });
    // },
    // reportsIndexCustomerTrends({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/index/customerTrends`,
    //     name: "REPORTS_INDEX_CUSTOMER_TRENDS",
    //     params
    //   });
    // },
    // reportsDeptOverview({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/dept/overview`,
    //     name: "REPORTS_DEPT_OVERVIEW",
    //     params
    //   });
    // },
    // reportsDeptTrends({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/dept/trends`,
    //     name: "REPORTS_DEPT_TRENDS",
    //     params
    //   });
    // },
    // reportsAchievementOverview({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/achievement/overview`,
    //     name: "REPORTS_ACHIEVEMENT_OVERVIEW",
    //     params
    //   });
    // },
    // reportsAchievementTrendsGroupByUser({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/achievement/trendsGroupByUser`,
    //     name: "REPORTS_ACHIEVEMENT_TRENDS_GROUP_BY_USER",
    //     params
    //   });
    // },
    // reportsGroupChatOverview({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/groupChat/overview`,
    //     name: "REPORTS_GROUP_CHAT_OVERVIEW",
    //     params
    //   });
    // },
    // reportsGroupChatTrends({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/groupChat/trends`,
    //     name: "REPORTS_GROUP_CHAT_TRENDS",
    //     params
    //   });
    // },
    // groupChatGetTrendsGroupByOwner({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/groupChat/getTrendsGroupByOwner`,
    //     name: "GROUP_CHAT_GET_TRENDS_GROUP_BY_OWNER",
    //     params
    //   });
    // },
    // customerOverview({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/customer/overview`,
    //     name: "CUSTOMER_OVERVIEW",
    //     params
    //   });
    // },
    // customerTrends({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/customer/trends`,
    //     name: "CUSTOMER_TRENDS",
    //     params
    //   });
    // },
    // storeComponentList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/component/list`,
    //     name: "STORE_COMPONENT_LIST",
    //     params
    //   });
    // },
    // scrmMarketingCreate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/create`,
    //     name: "SCRM_MARKETING_CREATE",
    //     params
    //   });
    // },
    // scrmMarketingDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/detail`,
    //     name: "SCRM_MARKETING_DETAIL",
    //     params
    //   });
    // },
    // scrmMarketingList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/list`,
    //     name: "SCRM_MARKETING_LIST",
    //     params
    //   });
    // },
    // scrmMarketingEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/edit`,
    //     name: "SCRM_MARKETING_EDIT",
    //     params
    //   });
    // },
    // scrmMarketingDelete({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/delete`,
    //     name: "SCRM_MARKETING_DELETE",
    //     params
    //   });
    // },
    // storeComponentColumnDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/component/column/detail`,
    //     name: "STORE_COMPONENT_COLUMN_DETAIL",
    //     params
    //   });
    // },
    // storeComponentColumns({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/component/columns`,
    //     name: "STORE_COMPONENT_COLUMNS",
    //     params
    //   });
    // },
    // storeComponentCouponEvent({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/component/coupon/event`,
    //     name: "STORE_COMPONENT_COUPON_EVENT",
    //     params
    //   });
    // },
    // scrmMarketingCreateProcess({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/create/process`,
    //     name: "SCRM_MARKETING_CREATE_PROCESS",
    //     params
    //   });
    // },
    // scrmMarketingEditProcess({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/edit/process`,
    //     name: "SCRM_MARKETING_EDIT_PROCESS",
    //     params
    //   });
    // },
    tagCategoryInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagCategoryInfo/queryPageList`,
        name: "TAG_CATEGORY_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    tagCategoryInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagCategoryInfo/add`,
        name: "TAG_CATEGORY_INFO_ADD",
        params
      });
    },
    tagCategoryInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagCategoryInfo/edit`,
        name: "TAG_CATEGORY_INFO_EDIT",
        params
      });
    },
    tagBasicInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/add`,
        name: "TAG_BASIC_INFO_ADD",
        params
      });
    },
    tagBasicInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/queryPageList`,
        name: "TAG_BASIC_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    tagBasicInfoQueryQueryById({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/queryById`,
        name: "TAG_BASIC_INFO_QUERY_QUERY_BY_ID",
        params
      });
    },
    tagBasicInfoEdit({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/edit`,
        name: "TAG_BASIC_INFO_EDIT",
        params
      });
    },
    tagBasicInfoQueryTagListByCategoryId({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/queryTagListByCategoryId`,
        name: "TAG_BASIC_INFO_QUERY_TAG_LIST_BY_CATEGORY_ID",
        params
      });
    },
    batchAddTagDataRangeConfigList({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataRangeConfig/batchAddTagDataRangeConfigList`,
        name: "BATCH_ADD_TAG_DATA_RANGE_CONFIG_LIST",
        params
      });
    },
    queryTagBasicInfoAndDataRangeConfigListByTagBasicId({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/queryTagBasicInfoAndDataRangeConfigListByTagBasicId`,
        name: "QUERY_TAG_BASIC_INFO_AND_DATA_RANGE_CONFIG_LIST_BY_TAG_BASIC_ID",
        params
      });
    },
    queryFieldListByIndex({ commit }, params) {
      return post({
        commit,
        url: `/metadata/mdElasticsearchFieldInfo/queryFieldListByTagDataId`,
        name: "QUERY_FIELD_LIST_BY_INDEX",
        params
      });
    },
    queryTagBasicInfoAndDataColumnConfigListByTagBasicId({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/queryTagBasicInfoAndDataColumnConfigListByTagBasicId`,
        name:
          "QUERY_TAG_BASIC_INFO_AND_DATA_COLUMN_CONFIG_LIST_BY_TAG_BASIC_ID",
        params
      });
    },
    tagDataRangeConfigAdd({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataRangeConfig/add`,
        name: "TAG_DATA_RANGE_CONFIG_ADD",
        params
      });
    },
    tagDataRangeConfigEdit({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataRangeConfig/edit`,
        name: "TAG_DATA_RANGE_CONFIG_EDIT",
        params
      });
    },
    tagDataRangeConfigRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataRangeConfig/removeByModel`,
        name: "TAG_DATA_RANGE_CONFIG_REMOVE_BY_MODEL",
        params
      });
    },
    tagDataColumnConfigAdd({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataColumnConfig/add`,
        name: "TAG_DATA_COLUMN_CONFIG_ADD",
        params
      });
    },
    tagDataColumnConfigEdit({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataColumnConfig/edit`,
        name: "TAG_DATA_COLUMN_CONFIG_EDIT",
        params
      });
    },
    tagDataColumnConfigRemoveByModel({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagDataColumnConfig/removeByModel`,
        name: "TAG_DATA_COLUMN_CONFIG_REMOVE_BY_MODEL",
        params
      });
    },
   
    // scrmMarketingAudit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/audit`,
    //     name: "SCRM_MARKETING_AUDIT",
    //     params
    //   });
    // },
    // staticTagOperateQueryTagListByBelongId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/running/tagOperate/queryTagListByBelongId`,
    //     name: "STATIC_TAG_OPERATE_QUERY_TAG_LIST_BY_BELONG_ID",
    //     params
    //   });
    // },
    // staticTagOperateUpdateStaticTagByBelongId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/running/tagOperate/updateStaticTagByBelongId`,
    //     name: "STATIC_TAG_OPERATE_UPDATE_STATIC_TAG_BY_BELONG_ID",
    //     params
    //   });
    // },
    // microStaticTagOperateUpdateStaticTagByBelongId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/tag/running/tagOperate/updateStaticTagByBelongId`,
    //     name: "MICRO_STATIC_TAG_OPERATE_UPDATE_STATIC_TAG_BY_BELONG_ID",
    //     params
    //   });
    // },
    // tagCategoryInfoQueryStaticFlatStruct({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/config/tagCategoryInfo/queryStaticFlatStruct`,
    //     name: "TAG_CATEGORY_INFO_QUERY_STATIC_FLAT_STRUCT",
    //     params
    //   });
    // },
    // tagCategoryInfoQueryStaticAndDynamicsFlatStruct({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/config/tagCategoryInfo/queryStaticAndDynamicsFlatStruct`,
    //     name: "TAG_CATEGORY_INFO_QUERY_STATIC_FLAT_STRUCT",
    //     params
    //   });
    // },
    staticTagOperateGetTagDataCount({ commit }, params) {
      return post({
        commit,
        url: `/tag/running/tagOperate/getTagDataCount`,
        name: "STATIC_TAG_OPERATE_GET_TAG_DATA_COUNT",
        params
      });
    },
    // getFactTableMemberInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getFactTableMemberInfo`,
    //     name: "GET_FACT_TABLE_MEMBER_INFO",
    //     params
    //   });
    // },
    // getFactTableMemberCategoryPreference({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getFactTableMemberCategoryPreference`,
    //     name: "GET_FACT_TABLE_MEMBER_CATEGORY_PREFERENCE",
    //     params
    //   });
    // },
    // getFactTableMemberBrandPreference({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getFactTableMemberBrandPreference`,
    //     name: "GET_FACT_TABLE_MEMBER_BRAND_PREFERENCE",
    //     params
    //   });
    // },
    // scrmWwCustomerFollowTagRelQueryTagListByCustomerId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwCustomerFollowTagRel/queryTagListByCustomerId`,
    //     name: "SCRM_WW_CUSTOMER_FOLLOW_TAG_REL_QUERY_TAG_LIST_BY_CUSTOMER_ID",
    //     params
    //   });
    // },
    // scrmWwGroupMemberInfoQueryGroupListByCustomerId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwGroupMemberInfo/queryGroupListByCustomerId`,
    //     name: "SCRM_WW_GROUP_MEMBER_INFO_QUERY_GROUP_LIST_BY_CUSTOMER_ID",
    //     params
    //   });
    // },
    // extractTagDataTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/running/tagOperate/extractTagDataTask`,
    //     name: "EXTRACT_TAG_DATA_TASK",
    //     params
    //   });
    // },
    exportTagDataCsv({ commit }, params) {
      return post({
        commit,
        url: `/tag/running/tagOperate/exportTagDataCsv`,
        name: "EXPORT_TAG_DATA_CSV",
        params
      });
    },
    // marketingTaskList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/task/list`,
    //     name: "MARKETING_TASK_LIST",
    //     params
    //   });
    // },
    // marketingTaskInstance({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/task/instance`,
    //     name: "MARKETING_TASK_INSTANCE",
    //     params
    //   });
    // },
    // guiderTaskList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/list`,
    //     name: "GUIDER_TASK_LIST",
    //     params
    //   });
    // },
    // guiderTaskAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/add`,
    //     name: "GUIDER_TASK_ADD",
    //     params
    //   });
    // },
    // guiderTaskUpdate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/update`,
    //     name: "GUIDER_TASK_UPDATE",
    //     params
    //   });
    // },
    // guiderRuleInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/rule/info`,
    //     name: "GUIDER_RULE_INFO",
    //     params
    //   });
    // },
    // mateTemplateList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/mateTemplateList`,
    //     name: "MATE_TEMPLATE_LIST",
    //     params
    //   });
    // },
    // mobileGuiderRuleInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/rule/info`,
    //     name: "MOBILE_GUIDER_RULE_INFO",
    //     params
    //   });
    // },
    // guiderRuleSetting({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/rule/setting`,
    //     name: "GUIDER_RULE_SETTING",
    //     params
    //   });
    // },
    // guiderTaskDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/detail`,
    //     name: "GUIDER_TASK_DETAIL",
    //     params
    //   });
    // },
    // guiderTaskDelete({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/delete`,
    //     name: "GUIDER_TASK_DELETE",
    //     params
    //   });
    // },
    // mobileGuiderTaskList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/list`,
    //     name: "MOBILE_GUIDER_TASK_LIST",
    //     params
    //   });
    // },
    // mobileGuiderTaskDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/detail`,
    //     name: "MOBILE_GUIDER_TASK_DETAIL",
    //     params
    //   });
    // },
    // mobileGuiderTaskDetailStatus({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/detail/status`,
    //     name: "MOBILE_GUIDER_TASK_DETAIL_STATUS",
    //     params
    //   });
    // },
    // querySysCategoryFrontendDisplayRootNodeList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/sysCategoryFrontendDisplayInfo/querySysCategoryFrontendDisplayRootNodeList`,
    //     name: "QUERY_SYS_CATEGORY_FRONTEND_DISPLAY_ROOT_NODE_LIST",
    //     params
    //   });
    // },
    querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId(
      { commit },
      params
    ) {
      return post({
        commit,
        url: `/sys/sysCategoryFrontendDisplayInfo/querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId`,
        name:
          "QUERY_SYS_CATEGORY_FRONTEND_DISPLAY_CHILD_NODE_LIST_BY_SYS_CATEGORY_FRONTEND_DISPLAY_ROOT_ID",
        params
      });
    },
    // microQuerySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId(
    //   { commit },
    //   params
    // ) {
    //   return post({
    //     commit,
    //     url: `/micro/sys/sysCategoryFrontendDisplayInfo/querySysCategoryFrontendDisplayChildNodeListBySysCategoryFrontendDisplayRootId`,
    //     name:
    //       "MICRO_QUERY_SYS_CATEGORY_FRONTEND_DISPLAY_CHILD_NODE_LIST_BY_SYS_CATEGORY_FRONTEND_DISPLAY_ROOT_ID",
    //     params
    //   });
    // },
    sysCategoryFrontendDisplayInfoAdd({ commit }, params) {
      return post({
        commit,
        url: `/sys/sysCategoryFrontendDisplayInfo/add`,
        name: "SYS_CATEGORY_FRONTEND_DISPLAY_INFO_ADD",
        params
      });
    },
    sysCategoryFrontendDisplayInfoUpdateById({ commit }, params) {
      return post({
        commit,
        url: `/sys/sysCategoryFrontendDisplayInfo/updateById`,
        name: "SYS_CATEGORY_FRONTEND_DISPLAY_INFO_UPDATE_BY_ID",
        params
      });
    },
    queryTagListBySysCategoryFrontendDisplayId({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagBasicInfo/queryTagListBySysCategoryFrontendDisplayId`,
        name: "QUERY_TAG_LIST_BY_SYS_CATEGORY_FRONTEND_DISPLAY_ID",
        params
      });
    },
    // batchAddTagDataColumnConfigList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/config/tagDataColumnConfig/batchAddTagDataColumnConfigList`,
    //     name: "BATCH_ADD_TAG_DATA_COLUMN_CONFIG_LIST",
    //     params
    //   });
    // },
    // updateStaticTagByList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/running/tagOperate/updateStaticTagByList`,
    //     name: "UPDATE_STATIC_TAG_BY_LIST",
    //     params
    //   });
    // },
    // importCustomTagData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/running/tagOperate/importCustomTagData`,
    //     name: "IMPORT_CUSTOM_TAG_DATA",
    //     params
    //   });
    // },
    tagCustomSourceInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/tag/config/tagCustomSourceInfo/queryPageList`,
        name: "TAG_CUSTOM_SOURCE_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    // tagCustomSourceInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/tag/config/tagCustomSourceInfo/queryById`,
    //     name: "TAG_CUSTOM_SOURCE_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // topicGroupList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/group/list`,
    //     name: "TOPIC_GROUP_LIST",
    //     params
    //   });
    // },
    // topicGroupCreate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/group/create`,
    //     name: "TOPIC_GROUP_CREATE",
    //     params
    //   });
    // },
    // topicGroupUpdate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/group/update`,
    //     name: "TOPIC_GROUP_UPDATE",
    //     params
    //   });
    // },
    // topicList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/list`,
    //     name: "TOPIC_LIST",
    //     params
    //   });
    // },
    // topicCreate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/create`,
    //     name: "TOPIC_CREATE",
    //     params
    //   });
    // },
    // topicEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/edit`,
    //     name: "TOPIC_EDIT",
    //     params
    //   });
    // },
    // topicDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/detail`,
    //     name: "TOPIC_DETAIL",
    //     params
    //   });
    // },
    // topicDelete({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/delete`,
    //     name: "TOPIC_DELETE",
    //     params
    //   });
    // },
    savePeoplePackage({ commit }, params) {
      return post({
        commit,
        url: `/config/tagDataCalcRuleInfo/savePeoplePackage`,
        name: "SAVE_PEOPLE_PACKAGE",
        params
      });
    },
    estimatePeoplePackage({ commit }, params) {
      return post({
        commit,
        url: `/tag/running/tagOperate/estimatePeoplePackage`,
        name: "ESTIMATE_PEOPLE_PACKAGE",
        params
      });
    },
    tagDataCalcRuleInfoQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/config/tagDataCalcRuleInfo/queryPageList`,
        name: "TAG_DATA_CALC_RULE_INFO_QUERY_PAGE_LIST",
        params
      });
    },
    tagOperateExecPeoplePackage({ commit }, params) {
      return post({
        commit,
        url: `/tag/running/tagOperate/execPeoplePackage`,
        name: "TAG_OPERATE_EXEC_PEOPLE_PACKAGE",
        params
      });
    },
    sysCategoryFrontendDisplayInfoQueryByName({ commit }, params) {
      return post({
        commit,
        url: `/sys/sysCategoryFrontendDisplayInfo/queryByName`,
        name: "SYS_CATEGORY_FRONTEND_DISPLAY_INFO_QUERY_BY_NAME",
        params
      });
    },
    scrmSchedulingRecordQueryPageList({ commit }, params) {
      return post({
        commit,
        url: `/system/sysSchedulingRecord/queryPageList`,
        name: "SCRM_SCHEDULING_RECORD_QUERY_PAGE_LIST",
        params
      });
    },
    downloadPeoplePackageResult({ commit }, params) {
      return post({
        commit,
        url: `/tag/running/tagOperate/downloadPeoplePackageResult`,
        name: "DOWNLOAD_PEOPLE_PACKAGE_RESULT",
        params
      });
    },
    // guiderTaskGroupMsg({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/groupMsg`,
    //     name: "GUIDER_TASK_GROUP_MSG",
    //     params
    //   });
    // },
    // guiderTaskMoment({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/moment`,
    //     name: "GUIDER_TASK_MOMENT",
    //     params
    //   });
    // },
    // guiderTaskFollow({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/follow`,
    //     name: "GUIDER_TASK_FOLLOW",
    //     params
    //   });
    // },
    // guiderTaskAccessToken({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/getAccessToken`,
    //     name: "GUIDER_TASK_ACCESS_TOKEN",
    //     params
    //   });
    // },
    // guiderTaskGetAgentToken({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/getAgentToken`,
    //     name: "GUIDER_TASK_GET_AGENT_TOKEN",
    //     params
    //   });
    // },
    // guiderTaskGetCorpInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/getCorpInfo`,
    //     name: "GUIDER_TASK_GET_CORP_INFO",
    //     params
    //   });
    // },
    // guiderTaskGetUserInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/getUserInfo`,
    //     name: "GUIDER_TASK_GET_USER_INFO",
    //     params
    //   });
    // },
    // weComLoginGetCorpInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/weComLogin/getCorpInfo`,
    //     name: "WE_COM_LOGIN_GET_CORP_INFO",
    //     params
    //   });
    // },
    // weComLoginGetWeComLoginUserInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/weComLogin/getWeComLoginUserInfo`,
    //     name: "WE_COM_LOGIN_GET_WE_COM_LOGIN_USER_INFO",
    //     params
    //   });
    // },
    // commonDictItems({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items`,
    //     name: "COMMON_DICT_ITEMS",
    //     params
    //   });
    // },
    // scrm_member_grade_name({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_member_grade_name`,
    //     name: "SCRM_MEMBER_GRADE_NAME",
    //     params
    //   });
    // },
    // scrm_member_grade({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_member_grade`,
    //     name: "SCRM_MEMBER_GRADE",
    //     params
    //   });
    // },
    // guiderTaskInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/info`,
    //     name: "GUIDER_TASK_INFO",
    //     params
    //   });
    // },
    // guiderTaskGuiderInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/guider/info`,
    //     name: "GUIDER_TASK_GUIDER_INFO",
    //     params
    //   });
    // },
    // guiderTaskStatusSummary({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/status/summary`,
    //     name: "GUIDER_TASK_STATUS_SUMMARY",
    //     params
    //   });
    // },
    // guiderTaskStatistics({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/statistics`,
    //     name: "GUIDER_TASK_STATISTICS",
    //     params
    //   });
    // },
    // getFactTableMemberActionList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/action/getFactTableMemberActionList`,
    //     name: "GET_FACT_TABLE_MEMBER_ACTION_LIST",
    //     params
    //   });
    // },
    // guiderTaskMemberFollow({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/member/follow`,
    //     name: "GUIDER_TASK_MEMBER_FOLLOW",
    //     params
    //   });
    // },
    // guiderTaskMemberFollowup({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/member/followup`,
    //     name: "GUIDER_TASK_MEMBER_FOLLOWUP",
    //     params
    //   });
    // },
    // getFactTableOrderMainList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/orderMain/getFactTableOrderMainList`,
    //     name: "GET_FACT_TABLE_ORDER_MAIN_LIST",
    //     params
    //   });
    // },
    // marketingSettingInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/setting/info`,
    //     name: "MARKETING_SETTING_INFO",
    //     params
    //   });
    // },
    // marketingSetting({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/setting`,
    //     name: "MARKETING_SETTING",
    //     params
    //   });
    // },
    // dkAdbMemberMetricsSearch({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dataSearch/dkAdbMemberMetricsSearch`,
    //     name: "DK_ADB_MEMBER_METRICS_SEARCH",
    //     params
    //   });
    // },
    // memberMetricsSearchQueryNewMemberAggsData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dataSearch/memberMetricsSearch/queryNewMemberAggsData`,
    //     name: "MEMBER_METRICS_SEARCH_QUERY_NEW_MEMBER_AGGS_DATA",
    //     params
    //   });
    // },
    // microDkAdbMemberMetricsSearchQueryAggsData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dataSearch/dkAdbMemberMetricsSearch/queryAggsData`,
    //     name: "MICRO_DK_ADB_MEMBER_METRICS_SEARCH_QUERY_AGGS_DATA",
    //     params
    //   });
    // },
    // getScrmStraffInfoByWeCom({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/getScrmStraffInfoByWeCom`,
    //     name: "GET_SCRM_STRAFF_INFO_BY_WE_COM",
    //     params
    //   });
    // },
    // smsSignList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sms/sign/list`,
    //     name: "SMS_SIGN_LIST",
    //     params
    //   });
    // },
    // smsTemplateList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sms/template/list`,
    //     name: "SMS_TEMPLATE_LIST",
    //     params
    //   });
    // },
    // marketingGroupList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/group/list`,
    //     name: "MARKETING_GROUP_LIST",
    //     params
    //   });
    // },
    // marketingGroupAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/group/add`,
    //     name: "MARKETING_GROUP_ADD",
    //     params
    //   });
    // },
    // marketingGroupUpdate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/group/update`,
    //     name: "MARKETING_GROUP_UPDATE",
    //     params
    //   });
    // },
    // dictCodeScrmDkadbCompanyName({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_dkadb_CompanyName`,
    //     name: "DICT_CODE_SCRM_DKADB_COMPANY_NAME",
    //     params
    //   });
    // },
    // dictCodeScrmMemberGradeCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_member_grade_code`,
    //     name: "DICT_CODE_SCRM_MEMBER_GRADE_CODE",
    //     params
    //   });
    // },
    // dictCodeScrmDkadbStaffid({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_dkadb_staffid`,
    //     name: "DICT_CODE_SCRM_DKADB_STAFFID",
    //     params
    //   });
    // },
    // peopleBasicSearchQueryData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/reports/dataBoard/peopleBasicSearch/queryData`,
    //     name: "PEOPLE_BASIC_SEARCH_QUERY_DATA",
    //     params
    //   });
    // },
    // marketingStatistics({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/statistics`,
    //     name: "MARKETING_STATISTICS",
    //     params
    //   });
    // },
    // marketingGroupOrderPage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/group/orderPage`,
    //     name: "MARKETING_GROUP_ORDERPAGE",
    //     params
    //   });
    // },
    // storeSystemParamInfoGetModelByParamCode({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/storepermissions/storeSystemParamInfo/getModelByParamCode`,
    //     name: "STORE_SYSTEM_PARAM_INFO_GET_MODEL_BY_PARAM_CODE",
    //     params
    //   });
    // },
    // storeSystemParamInfoEditValueById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/storepermissions/storeSystemParamInfo/editValueById`,
    //     name: "STORE_SYSTEM_PARAM_INFO_EDIT_VALUE_BY_ID",
    //     params
    //   });
    // },
    // marketingOverviewQueryAggsData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/reports/dataBoard/marketingOverview/queryAggsData`,
    //     name: "MARKETING_OVERVIEW_QUERY_AGGS_DATA",
    //     params
    //   });
    // },
    // marketingOverviewQueryMemberNumByHisDate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/reports/dataBoard/marketingOverview/queryMemberNumByHisDate`,
    //     name: "MARKETING_OVERVIEW_QUERY_MEMBER_NUM_BY_HIS_DATE",
    //     params
    //   });
    // },
    // memberOverviewSearchQueryMemberSaleAggData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/reports/dataBoard/memberOverviewSearch/queryMemberSaleAggData`,
    //     name: "MEMBER_OVERVIEW_SEARCH_QUERY_MEMBER_SALE_AGG_DATA",
    //     params
    //   });
    // },
    // memberOverviewSearchQueryPurchaseFreqSummary({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/reports/dataBoard/memberOverviewSearch/queryPurchaseFreqSummary`,
    //     name: "MEMBER_OVERVIEW_SEARCH_QUERY_PURCHASE_FREQ_SUMMARY",
    //     params
    //   });
    // },
    // queryFullInfoByStaffId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/queryFullInfoByStaffId`,
    //     name: "SCRM_STAFF_INFO_QUERY_FULL_INFO_BY_STAFFID",
    //     params
    //   });
    // },
    // editByStaffId({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/editByStaffId`,
    //     name: "SCRM_STAFF_INFO_EDITBYSTAFFID",
    //     params
    //   });
    // },
    // queryDataByStaff({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/queryDataByStaff`,
    //     name: "SCRM_STAFF_INFO_QUERYDATABYSTAFF",
    //     params
    //   });
    // },
    // scrmStaffInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/queryPageList`,
    //     name: "SCRM_STAFF_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmStaffInfoQueryRoleInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/queryRoleInfo`,
    //     name: "SCRM_STAFF_INFO_QUERY_ROLE_INFO",
    //     params
    //   });
    // },
    // scrmStaffInfoEmpEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/emp/edit`,
    //     name: "SCRM_STAFF_INFO_EMP_EDIT",
    //     params
    //   });
    // },
    // mobileGuiderTaskTeamTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/teamTask`,
    //     name: "MOBILE_GUIDER_TASK_TEAM_TASK",
    //     params
    //   });
    // },
    tagOperateRunTagDataCalc({ commit }, params) {
      return post({
        commit,
        url: `/tag/running/tagOperate/runTagDataCalc`,
        name: "TAG_OPERATE_RUN_TAG_DATA_CALC",
        params
      });
    },
    // scrmStaffInfoQueryDepartInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/queryDepartInfo`,
    //     name: "SCRM_STAFF_INFO_QUERY_DEPART_INFO",
    //     params
    //   });
    // },
    // shopTriggerEmpList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/shop/trigger/emp/list`,
    //     name: "SHOP_TRIGGER_EMP_LIST",
    //     params
    //   });
    // },
    // deptTriggerEmpList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dept/trigger/emp/list`,
    //     name: "DEPT_TRIGGER_EMP_LIST",
    //     params
    //   });
    // },
    // shopTriggerDeptList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/shop/trigger/dept/list`,
    //     name: "SHOP_TRIGGER_DEPT_LIST",
    //     params
    //   });
    // },
    // shopTriggerAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/shop/trigger/add`,
    //     name: "SHOP_TRIGGER_ADD",
    //     params
    //   });
    // },
    // deptTriggerAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dept/trigger/add`,
    //     name: "DEPT_TRIGGER_ADD",
    //     params
    //   });
    // },
    // scrmStaffInfoQueryStaffPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/scrmStaffInfo/queryStaffPageList`,
    //     name: "SCRM_STAFF_INFO_QUERY_STAFF_PAGE_LIST",
    //     params
    //   });
    // },
    // dictItemsGrade({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_member_grade_code`,
    //     name: "DICT_ITEMS_GRADE",
    //     params
    //   });
    // },
    dictItemsScrmGroupAnalysis({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/dict_items?dictCode=scrm_group_analysis`,
        name: "SCRM_GROUP_ANALYSIS",
        params
      });
    },
    // dictItemsScrmHomeDatebord({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items?dictCode=scrm_home_datebord`,
    //     name: "SCRM_HOME_DATEBORD",
    //     params
    //   });
    // },
    // dictItemsScrmMobileDateboard({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/common/dict_items_noToken?dictCode=scrm_mobile_dateboard`,
    //     name: "SCRM_MOBILE_DATEBOARD",
    //     params
    //   });
    // },
    // getFactTableMemberInfoList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/factTable/member/getFactTableMemberInfoList`,
    //     name: "GET_FACT_TABLE_MEMBER_INFO_LIST",
    //     params
    //   });
    // },
    // dynamicsDataBasicInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataBasicInfo/queryPageList`,
    //     name: "DYNAMICS_DATA_BASIC_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // dynamicsDataBasicInfoAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataBasicInfo/add`,
    //     name: "DYNAMICS_DATA_BASIC_INFO_ADD",
    //     params
    //   });
    // },
    // dynamicsDataBasicInfoEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataBasicInfo/edit`,
    //     name: "DYNAMICS_DATA_BASIC_INFO_EDIT",
    //     params
    //   });
    // },
    // dynamicsDataBasicInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataBasicInfo/queryById`,
    //     name: "DYNAMICS_DATA_BASIC_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // dynamicsDataColumnConfigBatchAddDynamicsDataColumnDataColumnConfigList(
    //   { commit },
    //   params
    // ) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataColumnConfig/batchAddDynamicsDataColumnDataColumnConfigList`,
    //     name:
    //       "DYNAMICS_DATA_COLUMN_CONFIG_BATCH_ADD_DYNAMICS_DATA_COLUMN_DATA_COLUMN_CONFIG_LIST",
    //     params
    //   });
    // },
    // dynamicsDataColumnConfigAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataColumnConfig/add`,
    //     name: "DYNAMICS_DATA_COLUMN_CONFIG_ADD",
    //     params
    //   });
    // },
    // dynamicsDataColumnConfigEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataColumnConfig/edit`,
    //     name: "DYNAMICS_DATA_COLUMN_CONFIG_EDIT",
    //     params
    //   });
    // },
    // dynamicsDataColumnConfigQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataColumnConfig/queryById`,
    //     name: "DYNAMICS_DATA_COLUMN_CONFIG_QUERY_BY_ID",
    //     params
    //   });
    // },
    // dynamicsDataAggsProcQueryDynamicsDataAggsStatsResult({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataAggsProc/queryDynamicsDataAggsStatsResult`,
    //     name: "DYNAMICS_DATA_AGGS_PROC_QUERY_DYNAMICS_DATA_AGGS_STATS_RESULT",
    //     params
    //   });
    // },
    // customerStatic({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/user/customerStatic`,
    //     name: "CUSTOMER_STATIC",
    //     params
    //   });
    // },
    // storeSystemParamInfoGetParamValueNoToken({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/storepermissions/storeSystemParamInfo/getParamValueNoToken`,
    //     name: "STORE_SYSTEM_PARAM_INFO_GET_PARAM_VALUE_NO_TOKEN",
    //     params
    //   });
    // },
    // scrmWwGroupInfoGroupOwnerTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwGroupInfo/groupOwnerTask`,
    //     name: "SCRM_WW_GROUP_INFO_GROUP_OWNER_TASK",
    //     params
    //   });
    // },
    // saleData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataNormalProc/queryDynamicsDataNormalListResult`,
    //     name: "SALE_DATA",
    //     params
    //   });
    // },
    // dynamicsSaleData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataAggsProc/queryDynamicsDataAggsListResult`,
    //     name: "DYNAMICS_SALE_DATA",
    //     params
    //   });
    // },
    // dynamicsDataAggsProcQueryDynamicsDataAggsListResult({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataAggsProc/queryDynamicsDataAggsListResult`,
    //     name: "DYNAMICS_DATA_AGGS_PROC_QUERY_DYNAMICS_DATA_AGGS_LIST_RESULT",
    //     params
    //   });
    // },
    // statsUserOverview({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/stats/user/overview`,
    //     name: "STATS_USER_OVERVIEW",
    //     params
    //   });
    // },
    // queryDynamicsDataAggsStatsResult({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataAggsProc/queryDynamicsDataAggsStatsResult`,
    //     name: "QUERY_DYNAMICS_DATA_AGGS_STATS_RESULT",
    //     params
    //   });
    // },
    // queryDynamicsDataAggsListResult({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataAggsProc/queryDynamicsDataAggsListResult`,
    //     name: "QUERY_DYNAMICS_DATA_AGGS_LIST_RESULT",
    //     params
    //   });
    // },
    // queryCountDynamicsDataMultiplyTable({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataMultiplyTableProc/queryCountDynamicsDataMultiplyTable`,
    //     name: "QUERY_COUNT_DYNAMICS_DATA_MULTIPLY_TABLE",
    //     params
    //   });
    // },
    // queryDynamicsDataNormalListResult({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataNormalProc/queryDynamicsDataNormalListResult`,
    //     name: "QUERY_DYNAMICS_DATA_NORMAL_LIST_RESULT",
    //     params
    //   });
    // },
    getPlusMemberCardList({ commit }, params) {
      return post({
        commit,
        url: `/basic/plus/getPlusMemberCardList`,
        name: "GET_PLUS_MEMBER_CARD_LIST",
        params
      });
    },
    // getPlusMemberIncreaseCardList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/factTable/plus/member/getPlusMemberIncreaseCardList`,
    //     name: "GET_PLUS_MEMBER_INCREASE_CARD_LIST",
    //     params
    //   });
    // },
    // taskReport({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/report`,
    //     name: "TASK_REPORT",
    //     params
    //   });
    // },
    // queryDeptDataScope({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/dataScpoe/queryDepartDataScope`,
    //     name: "DEPT_DATE_SCOPE",
    //     params
    //   });
    // },
    // queryStaffDataScope({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/corp/dataScpoe/queryStaffDataScope`,
    //     name: "STAFF_DATE_SCOPE",
    //     params
    //   });
    // },
    // tagTrendsQueryDateRangeList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/tagTrends/queryDateRangeList`,
    //     name: "TAG_TRENDS_QUERY_DATE_RANGE_LIST",
    //     params
    //   });
    // },
    // guiderTaskReportDate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/report/date`,
    //     name: "GUIDER_TASK_REPORT_DATE",
    //     params
    //   });
    // },
    // guiderTaskRank({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/rank`,
    //     name: "GUIDER_TASK_RANK",
    //     params
    //   });
    // },
    // guiderTaskRankGuider({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/rank/guider`,
    //     name: "GUIDER_TASK_RANK_GUIDER",
    //     params
    //   });
    // },
    // queryActTypeList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/store/dict/item/list`,
    //     name: "QUERY_ACT_TYPE_LIST",
    //     params
    //   });
    // },
    // mobileGuiderTaskFeedbacks({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/mobile/guider/task/feedbacks`,
    //     name: "MOBILE_GUIDER_TASK_FEEDBACKS",
    //     params
    //   });
    // },
    // getMemberAnalysisCategoryPreference({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getMemberAnalysisCategoryPreference`,
    //     name: "GET_MEMBER_ANALYSIS_CATEGORY_PREFERENCE",
    //     params
    //   });
    // },
    // getMemberAnalysisBrandPreference({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getMemberAnalysisBrandPreference`,
    //     name: "GET_MEMBER_ANALYSIS_BRAND_PREFERENCE",
    //     params
    //   });
    // },
    // searchUserPermission({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/sys/permission/searchUserPermission`,
    //     name: "SEARCH_USER_PERMISSION",
    //     params
    //   });
    // },
    // updateFactTableMember({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/factTable/member/updateFactTableMember`,
    //     name: "UPDATE_FACT_TABLE_MEMBER",
    //     params
    //   });
    // },
    // dynamicsDataDashboardPageInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataDashboardPageInfo/queryPageList`,
    //     name: "DYNAMICS_DATA_DASHBOARD_PAGE_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // dynamicsDataDashboardPageInfoAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataDashboardPageInfo/add`,
    //     name: "DYNAMICS_DATA_DASHBOARD_PAGE_INFO_ADD",
    //     params
    //   });
    // },
    // dynamicsDataDashboardPageInfoEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataDashboardPageInfo/edit`,
    //     name: "DYNAMICS_DATA_DASHBOARD_PAGE_INFO_EDIT",
    //     params
    //   });
    // },
    // dynamicsDataDashboardPageInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataDashboardPageInfo/queryById`,
    //     name: "DYNAMICS_DATA_DASHBOARD_PAGE_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // dynamicsDataReportTemplateInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/dynamics/dynamicsDataReportTemplateInfo/queryPageList`,
    //     name: "DYNAMICS_DATA_REPORT_TEMPLATE_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    dynamicsDataReportTemplateInfoObtainDynamicsDataReport({ commit }, params) {
      return post({
        commit,
        url: `/provider/es/micro/dynamics/dynamicsDataReportTemplateInfo/obtainDynamicsDataReport`,
        name: "DYNAMICS_DATA_REPORT_TEMPLATE_INFO_OBTAIN_DYNAMICS_DATA_REPORT",
        params
      });
    },
    // marketingSbuMsgList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/sbuMsg/list`,
    //     name: "MARKETING_SBU_MSG_LIST",
    //     params
    //   });
    // },
    // guiderTaskExport({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/guider/task/export`,
    //     name: "GUIDER_TASK_EXPORT",
    //     params
    //   });
    // },
    // microTopicGroupList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/topic/group/list`,
    //     name: "MICRO_TOPIC_GROUP_LIST",
    //     params
    //   });
    // },
    // microTopicList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/topic/list`,
    //     name: "MICRO_TOPIC_LIST",
    //     params
    //   });
    // },
    // getFactTableMemberMilkCategoryPreference({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getFactTableMemberMilkCategoryPreference`,
    //     name: "GET_FACT_TABLE_MEMBER_MILK_CATEGORY_PREFERENCE",
    //     params
    //   });
    // },
    // getFactTableMemberPaperCategoryPreference({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/factTable/member/getFactTableMemberPaperCategoryPreference`,
    //     name: "GET_FACT_TABLE_MEMBER_PAPER_CATEGORY_PREFERENCE",
    //     params
    //   });
    // },
    // exportFactTableMemberInfoList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/factTable/member/exportFactTableMemberInfoList`,
    //     name: "EXPORT_FACT_TABLE_MEMBER_INFO_LIST",
    //     params
    //   });
    // },
    // scrmMarketingRd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/marketing/rd`,
    //     name: "SCRM_MARKETING_RD",
    //     params
    //   });
    // },
    //
    // scrmMicroWwQrCodeInfoQueryPageList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/wechatCp/corp/scrmWwQrCodeInfo/queryPageList`,
    //     name: "MICRO_SCRM_WW_QR_CODE_INFO_QUERY_PAGE_LIST",
    //     params
    //   });
    // },
    // scrmMicroWwQrCodeInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/wechatCp/corp/scrmWwQrCodeInfo/queryById`,
    //     name: "MICRO_SCRM_WW_QR_CODE_INFO_QUERY_BY_Id",
    //     params
    //   });
    // },
    // scrmMicroWwQrCodeInfoQueryDailyStatDataById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/wechatCp/corp/scrmWwQrCodeInfo/queryDailyStatDataById`,
    //     name: "MICRO_SCRM_WW_QR_CODE_INFO_QUERY_DAILY_STAT_DATA_BY_ID",
    //     params
    //   });
    // },
    // microScrmWwQrCodeInfoQueryTotalStatDataById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/wechatCp/corp/scrmWwQrCodeInfo/queryTotalStatDataById`,
    //     name: "MICRO_SCRM_WW_QR_CODE_INFO_QUERY_TOTAL_STAT_DATA_BY_ID",
    //     params
    //   });
    // },
    // scrmFormList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/list`,
    //     name: "SCRM_FORM_LIST",
    //     params
    //   });
    // },
    // scrmFormQueryCommonItems({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/queryCommonItems`,
    //     name: "SCRM_FORM_QUERYCOMMONITEMS",
    //     params
    //   });
    // },
    // scrmFormAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/add`,
    //     name: "SCRM_FORM_ADD",
    //     params
    //   });
    // },
    // scrmFormDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/detail`,
    //     name: "SCRM_FORM_DETAIL",
    //     params
    //   });
    // },
    // scrmFormUpdate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `scrm/form/update`,
    //     name: "SCRM_FORM_UPDATE",
    //     params
    //   });
    // },
    // scrmFormDelete({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/delete`,
    //     name: "SCRM_FORM_DELETE",
    //     params
    //   });
    // },
    // scrmFormData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/data`,
    //     name: "SCRM_FORM_DATA",
    //     params
    //   });
    // },
    // scrmFormClose({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/close`,
    //     name: "SCRM_FORM_CLOSE",
    //     params
    //   });
    // },
    // scrmFormDataDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/dataDetail`,
    //     name: "SCRM_FORM_DATADETAIL",
    //     params
    //   });
    // },
    // scrmFormShare({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/share`,
    //     name: "SCRM_FORM_SHARE",
    //     params
    //   });
    // },
    // wechatCpCorpScrmWwMaterialInfoDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/wechatCp/corp/scrmWwMaterialInfo/detail`,
    //     name: "WECHATCP_CORP_SCRMWWMATERIALINFO_DETAIL",
    //     params
    //   });
    // },
    // scrmTopicStat({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/stat`,
    //     name: "SCRM_TOPIC_STAT",
    //     params
    //   });
    // },
    // scrmTopicEmpStat({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/topic/empStat`,
    //     name: "SCRM_TOPIC_EMPSTAT",
    //     params
    //   });
    // },
    // microCorpDataScpoeQueryDepartDataScope({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/corp/dataScpoe/queryDepartDataScope`,
    //     name: "MICRO_CORP_DATA_SCPOE_QUERY_DEPART_DATA_SCOPE",
    //     params
    //   });
    // },
    // microCorpDataScpoeQueryStaffDataScope({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/corp/dataScpoe/queryStaffDataScope`,
    //     name: "MICRO_CORP_DATA_SCPOE_QUERY_STAFF_DATA_SCOPE",
    //     params
    //   });
    // },
    // microDynamicsDataDashboardPageInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/dynamics/dynamicsDataDashboardPageInfo/queryById`,
    //     name: "MICRO_DYNAMICS_DATA_DASHBOARD_PAGE_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // scrmFormSubmit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/submit`,
    //     name: "SCRM_FORM_SUBMIT",
    //     params
    //   });
    // },
    // dataScpoeGetDataScope({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/micro/corp/dataScpoe/getDataScope`,
    //     name: "DATA_SCPOE_GET_DATA_SCOPE",
    //     params
    //   });
    // },
    // scrmFormMemberDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/form/memberDetail`,
    //     name: "SCRM_FORM_MEMBERDETAIL",
    //     params
    //   });
    // },
    // submitData({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/form/submit/data",
    //     name: "SUBMIT_DATA",
    //     params
    //   });
    // },
    // scrmFormSubmitDetail({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/form/submit/detail",
    //     name: "SCRM_FORM_SUBMIT_DETAIL",
    //     params
    //   });
    // },
    // queryAliasMappingListByCategoryFrontendDisplayId({ commit }, params) {
    //   return post({
    //     commit,
    //     url:
    //       "/micro/sys/sysAliasMappingInfo/queryAliasMappingListByCategoryFrontendDisplayId",
    //     name: "QUERY_ALIAS_MAPPING_LIST_BY_CATEGORY_FRONTEND_DISPLAY_ID",
    //     params
    //   });
    // },
    // sysAliasMappingInfoAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/sys/sysAliasMappingInfo/add",
    //     name: "SYS_ALIAS_MAPPING_INFO_ADD",
    //     params
    //   });
    // },
    // sysAliasMappingInfoEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/sys/sysAliasMappingInfo/edit",
    //     name: "SYS_ALIAS_MAPPING_INFO_EDIT",
    //     params
    //   });
    // },
    // sysAliasMappingInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/sys/sysAliasMappingInfo/queryById",
    //     name: "SYS_ALIAS_MAPPING_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // microSysAliasMappingInfoQueryById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/micro/sys/sysAliasMappingInfo/queryById",
    //     name: "MICRO_SYS_ALIAS_MAPPING_INFO_QUERY_BY_ID",
    //     params
    //   });
    // },
    // sysAliasMappingInfoRemoveByModel({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/sys/sysAliasMappingInfo/removeByModel",
    //     name: "SYS_ALIAS_MAPPING_INFO_REMOVE_BY_MODEL",
    //     params
    //   });
    // },
    // microSysCategoryFrontendDisplayInfoQueryByName({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/micro/sys/sysCategoryFrontendDisplayInfo/queryByName",
    //     name: "MICRO_SYS_CATEGORY_FRONTEND_DISPLAY_INFO_QUERY_BY_NAME",
    //     params
    //   });
    // },
    // getCrowdPackageWecomExternalContact({ commit }, params) {
    //   return post({
    //     commit,
    //     url:
    //       "/micro/tag/running/tagOperate/getCrowdPackageWecomExternalContact",
    //     name: "GET_CROWD_PACKAGE_WECOM_EXTERNAL_CONTACT",
    //     params
    //   });
    // },
    // topicStatAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/topic/stat/add",
    //     name: "TOPIC_STAT_ADD",
    //     params
    //   });
    // },
    // tagOperatePushToWeComGroupTag({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/running/tagOperate/pushToWeComGroupTag",
    //     name: "TAG_OPERATE_PUSH_TO_WE_COM_GROUP_TAG",
    //     params
    //   });
    // },
    // tagOperatePushToWeComTagUser({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/running/tagOperate/pushToWeComTagUser",
    //     name: "TAG_OPERATE_PUSH_TO_WE_COM_TAG_USER",
    //     params
    //   });
    // },
    // scrmMobileGuiderTaskFollowInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/mobile/guider/task/follow/info",
    //     name: "SCRM_MOBILE_GUIDER_TASK_FOLLOW_INFO",
    //     params
    //   });
    // },
    // scrmMobileGuiderTaskStatic({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/mobile/guider/task/static",
    //     name: "SCRM_MOBILE_GUIDER_TASK_STATIC",
    //     params
    //   });
    // },
    // scrmMobileGuiderTaskCnt({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/mobile/guider/task/cnt",
    //     name: "SCRM_MOBILE_GUIDER_TASK_CNT",
    //     params
    //   });
    // },
    // scrmMobileGuiderTaskMobileStatic({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/mobile/guider/task/taskMobileStatic",
    //     name: "SCRM_MOBILE_GUIDER_TASK_TASKMOBILESTATIC",
    //     params
    //   });
    // },
    //
    // mobileHomeTaskStatistics({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/new/mobile/guider/task/mobileHomeTaskStatistics",
    //     name: "QUERY_TASK_MOBILEHOMETASKSTATISTICS",
    //     params
    //   });
    // },
    // getFactTableMemberStats({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/micro/factTable/member/getFactTableMemberStats",
    //     name: "GETFACTTABLEMEMBERSTATS",
    //     params
    //   });
    // },
    // getMobileHomeDayTaskDetailList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/new/mobile/guider/task/mobileHomeDayTaskDetailList",
    //     name: "MOBILE_HOME_DAY_TASK_DETAIL_LIST",
    //     params
    //   });
    // },
    // queryStoreTaskRuleTypeCount({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/new/mobile/guider/task/queryStoreTaskRuleTypeCount",
    //     name: "QUERY_STORE_TASK_RULE_TYPE_COUNT",
    //     params
    //   });
    // },
    // guiderMobileTaskInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: `/scrm/new/mobile/guider/task/taskInfoSummary`,
    //     name: "MOBILE_GUIDER_TASK_INFO",
    //     params
    //   });
    // },
    //
    // queryTaskDeptInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     // /scrm/new/mobile/guider/task
    //     url: "/scrm/new/mobile/guider/task/taskDeptInfo",
    //     name: "GUIDER_TASK_TASKDEPTINFO",
    //     params
    //   });
    // },
    // getMobileGuiderTabTaskList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/mobile/guider/task/getMobileGuiderTabTaskList",
    //     name: "GET_MOBILE_GUIDER_TAB_TASK_LIST",
    //     params
    //   });
    // },
    // exportTask({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/guider/task/exportTask",
    //     name: "SCRM_GUIDER_TASK_EXPORTTASK",
    //     params
    //   });
    // },
    // canvasDailyStatistics({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/micro/scrm/marketingStatistics/canvasDailyStatistics",
    //     name: "CANVAS_DAILY_STATISTICS",
    //     params
    //   });
    // },
    // queryAuthTagList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/guider/task/queryAuthTagList",
    //     name: "QUERY_AUTH_TAGLIST",
    //     params
    //   });
    // },
    // getMarketingParamValueList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/marketing/getMarketingParamValueList",
    //     name: "GET_MARKETING_PARAM_VALUELIST",
    //     params
    //   });
    // },
    // queryMessageTemplatePage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageTemplates/queryMessageTemplatePage",
    //     name: "QUERY_MESSAGE_TEMPLATE_PAGE",
    //     params
    //   });
    // },
    //
    // deleteMessageTemplateById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageTemplates/deleteMessageTemplateById",
    //     name: "DELETE_MESSAGE_TEMPLATE_PAGE",
    //     params
    //   });
    // },
    //
    // editMessageTemplate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageTemplates/editMessageTemplate",
    //     name: "EDIT_MESSAGE_TEMPLATE_PAGE",
    //     params
    //   });
    // },
    //
    // addMessageTemplate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageTemplates/addMessageTemplate",
    //     name: "ADD_MESSAGE_TEMPLATE_PAGE",
    //     params
    //   });
    // },
    //
    // queryMessageTemplateById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageTemplates/queryMessageTemplateById",
    //     name: "QUERY_MESSAGE_TEMPLATE_BY_ID",
    //     params
    //   });
    // },
    //
    // queryMessageTemplateCategory({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageTemplates/queryMessageTemplateCategory",
    //     name: "QUERY_MESSAGE_TEMPLATE_CATEGORY",
    //     params
    //   });
    // },
    //
    // queryMessageRulesPage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageRules/queryMessageRulesPage",
    //     name: "QUERY_MESSAGE_RULES_PAGE",
    //     params
    //   });
    // },
    //
    // addMessageRules({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageRules/addMessageRules",
    //     name: "ADD_MESSAGE_RULES",
    //     params
    //   });
    // },
    //
    // queryMessageRulesById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageRules/queryMessageRulesById",
    //     name: "QUERY_MESSAGE_RULES_BY_ID",
    //     params
    //   });
    // },
    //
    // editMessageRules({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageRules/editMessageRules",
    //     name: "EDIT_MESSAGE_RULES",
    //     params
    //   });
    // },
    // pushMessage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageRules/pushMessage",
    //     name: "PUSH_MESSAGE",
    //     params
    //   });
    // },
    // queryThirdInterfaceInvokePage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/log/queryThirdInterfaceInvokePage",
    //     name: "QUERY_THIRD_INTERFACE_INVOKE_PAGE",
    //     params
    //   });
    // },
    // delMessageRules({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/system/messageRules/delMessageRules",
    //     name: "DEL_MESSAGE_RULES",
    //     params
    //   });
    // },
    // queryUserStaffCompPage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/corp/scrmStaffInfo/queryUserStaffCompPage",
    //     name: "QUERY_USER_STAFF_COMPAGE",
    //     params
    //   });
    // },
    // syncUserStaffComp({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/corp/scrmStaffInfo/syncUserStaffComp",
    //     name: "SYNC_USER_STAFF_COMP",
    //     params
    //   });
    // },
    // cancelUserStaffComp({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/corp/scrmStaffInfo/cancelUserStaffComp",
    //     name: "CANCEL_USER_STAFF_COMP",
    //     params
    //   });
    // },
    // editTagCustomSourceInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/config/tagCustomSourceInfo/edit",
    //     name: "EDIT_TAG_CUSTOM_SOURCEINFO",
    //     params
    //   });
    // },
    // checkUsageTagCustomSourceInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/config/tagCustomSourceInfo/checkUsage",
    //     name: "CHECK_USAGE_TAG_CUSTOM_SOURCEINFO",
    //     params
    //   });
    // },
    // delAllInfoById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/config/tagCustomSourceInfo/delAllInfoById",
    //     name: "DEL_ALL_INFO_BYID",
    //     params
    //   });
    // },
    // editTagDataCalcRuleInfo({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/config/tagDataCalcRuleInfo/edit",
    //     name: "EDIT_TAG_DATA_CALC_RULEINFO",
    //     params
    //   });
    // },
    checkUsageTagDataCalcRuleInfo({ commit }, params) {
      return post({
        commit,
        url: "/config/tagDataCalcRuleInfo/checkUsage",
        name: "CHECKUSAGE_TAG_DATA_CALC_RULEINFO",
        params
      });
    },
    delCalcTagAllInfoById({ commit }, params) {
      return post({
        commit,
        url: "/config/tagDataCalcRuleInfo/delAllInfoById",
        name: "DEL_CALC_TAGALLINFO_BYID",
        params
      });
    },
    // updateTaskName({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/guider/task/updateTaskName",
    //     name: "UPDATE_TASK_NAME",
    //     params
    //   });
    // },
    // exportTagDataCsvCustom({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/running/tagOperate/exportTagDataCsvCustom",
    //     name: "EXPORT_TAG_DATA_CSVCUSTOM",
    //     params
    //   });
    // },
    queryExportTagField({ commit }, params) {
      return post({
        commit,
        url: "/tag/running/tagOperate/queryExportTagField",
        name: "QUERY_EXPORT_TAGFIELD",
        params
      });
    },
    // exportSummaryList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/guider/task/exportSummaryList",
    //     name: "EXPORT_SUMMARY_LIST",
    //     params
    //   });
    // },
    // obtainDynamicsDataReport({ commit }, params) {
    //   return post({
    //     commit,
    //     url:
    //       "/micro/dynamics/dynamicsDataReportTemplateInfo/obtainDynamicsDataReport",
    //     name: "OBTAIN_DYNAMICS_DATA_REPORT",
    //     params
    //   });
    // },
    // queryGroupBrandStatistics({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/statistics/queryGroupBrandStatistics",
    //     name: "QUERY_GROUP_BRAND_STATISTICS",
    //     params
    //   });
    // },
    // queryBrandRulePage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/rule/queryBrandRulePage",
    //     name: "QUERY_BRAND_RULE_PAGE",
    //     params
    //   });
    // },
    // queryBrandMemberPage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/statistics/queryBrandMemberPage",
    //     name: "QUERY_BRAND_MEMBERPAGE",
    //     params
    //   });
    // },
    // addBrandRule({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/rule/addBrandRule",
    //     name: "ADD_BRAND_Rule",
    //     params
    //   });
    // },
    // pushThisMonthBrandNewMember({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/rule/pushThisMonthBrandNewMember",
    //     name: "PUSH_THIS_MONTH_BRAND_NEW_MEMBER",
    //     params
    //   });
    // },
    // exportBrandMember({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/statistics/exportBrandMember",
    //     name: "EXPORT_BRAND_MEMBER",
    //     params
    //   });
    // },
    // addBrandTagOperate({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/brand/statistics/addBrandTagOperate",
    //     name: "ADD_BRAND_MEMBER",
    //     params
    //   });
    // },
    // estimatePeoplePlusPackage({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/tag/running/tagOperate/estimatePeoplePlusPackage",
    //     name: "ESTIMATE_PEOPLE_PLUS_PACKAGE",
    //     params
    //   });
    // },
    // getMemberInfoListForApi({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/micro/factTable/member/getMemberInfoListForApi",
    //     name: "GET_MEMBER_INFO_LIST_API",
    //     params
    //   });
    // },
    // marketingMateTemplateList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/scrm/marketing/marketingMateTemplateList",
    //     name: "MARKETING_MATE_TEMPLATE_LIST",
    //     params
    //   });
    // },
    // tagOrmInfoAdd({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/config/tagOrmInfo/add",
    //     name: "TAG_ORMINFO_ADD",
    //     params
    //   });
    // },
    // tagOrmInfoEdit({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/config/tagOrmInfo/edit",
    //     name: "TAG_ORMINFO_EDIT",
    //     params
    //   });
    // },
    // queryTagOrmInfoById({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/config/tagOrmInfo/queryById",
    //     name: "QUERY_TAG_ORMINFO_BYID",
    //     params
    //   });
    // },
    // queryTagOrmInfoList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/config/tagOrmInfo/queryPageList",
    //     name: "QUERY_YAG_ORMINFO_LIST",
    //     params
    //   });
    // },
    // removeTagOrmInfoList({ commit }, params) {
    //   return post({
    //     commit,
    //     url: "/config/tagOrmInfo/removeByModel",
    //     name: "REMOVE_YAG_ORMINFO_LIST",
    //     params
    //   });
    // }
  }
};

export default stock;
